import { Card,  Col, Collapse } from "reactstrap";
import { useState } from "react";
import DesignCategories from "./DesignCategories";
import DevelopmentCategories from "./DevelopmentCategories";
import CommonLearningHeader from "../Common/CommonLearningHeader";
import { CategoriesTitleLearning } from "../../../../../Constant";

const CategoriesCheckBoxes = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Col xl="12">
      <Card>
        <CommonLearningHeader heading={CategoriesTitleLearning} isOpen={isOpen} setIsOpen={setIsOpen}/> 
        <Collapse isOpen={isOpen} className="card-body px-0">
          <DesignCategories />
          <DevelopmentCategories />
        </Collapse>
      </Card>
    </Col>
  );
};

export default CategoriesCheckBoxes;
